export default "__VITE_ASSET__BFrVvWO9__"